// extracted by mini-css-extract-plugin
export default {"wrapper":"issues_wrapper__BPGxx","container":"issues_container__gfF-E","box":"issues_box__j+2Yp"};